import { render, staticRenderFns } from "./MedicationPlanForm.vue?vue&type=template&id=4c3d0fe4&scoped=true&"
import script from "./MedicationPlanForm.vue?vue&type=script&lang=js&"
export * from "./MedicationPlanForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c3d0fe4",
  null
  
)

export default component.exports